import { gql } from 'graphql-request';

export const CACHE_INVOICE_PAY_ASYNC_QUERY = gql`
  mutation CacheInvoicePayAsync(
    $uuid: ID!
    $paymentMethod: String!
    $paymentDate: String
    $confirmationId: String
    $fileAttachmentId: ID
    $paid: Float
    $received: Float
    $transactionFeeExpense: Float
  ) {
    invoicePayAsync(
      input: {
        uuid: $uuid
        paymentMethod: $paymentMethod
        paymentDate: $paymentDate
        confirmationId: $confirmationId
        fileAttachmentId: $fileAttachmentId
        paid: $paid
        received: $received
        transactionFeeExpense: $transactionFeeExpense
      }
    ) {
      errors {
        fullMessages
      }
      status
    }
  }
`;
